const $ = window.jQuery;

let s = {
	body : $('body'),
	push : $('.js-push'),

	pushMenuSwitch : 1140,

	touchLengthMinX : 26,
	touchLengthMaxY : 26,

	// pushMenu         : $('.js-push__menu'),
	pushMenuSelector : '.js-push__menu',

	// pushContent : $('.js-push__content'),
	pushContentSelector : '.js-push__content',

	// menuToggle         : $('.js-menu__toggle'),
	menuToggleSelector : '.js-menu__toggle',

	// menuClose         : $('.js-menu__close'),
	menuCloseSelector : '.js-menu__close',

	// Button selectors for show/hide
	menuOpenButtonSelector : '.menu-toggle--open',
	menuCloseButtonSelector : '.menu-toggle--close',

	// pushLevelForward         : $('.js-menu__item--has-children > a'),
	// pushLevelForwardSelector : '.js-menu__item--has-children > a',
	// pushLevelForward         : $('.js-push__menu .menu-item-has-children > a'),
	pushLevelForwardSelector : '.js-push__menu .menu-item-has-children > span',

	// pushLevelBack         : $('.js-menu__back'),
	pushLevelBackSelector : '.js-menu__back',

	// Accordion selectors for submenu items
	accordionTriggerSelector : '.js-menu__accordion-trigger',
	accordionContentSelector : '.js-menu__accordion-content',

	// Header selector for dynamic positioning
	headerSelector : '.o-header, header, .header, .site-header',

	// Search container selector
	searchContainerSelector : '.search-container--top-level',
};

function init() {
	events();
	updateMenuPosition();
}

function updateMenuPosition() {
	// Only update on mobile
	if (window.innerWidth >= s.pushMenuSwitch) {
		return;
	}

	const $header = $(s.headerSelector).first();
	const $menu = $(s.pushMenuSelector);
	
	if ($header.length && $menu.length) {
		const headerHeight = $header.outerHeight();
		// Use window.innerHeight instead of vh for iOS
		const viewportHeight = window.innerHeight;
		
		// Set both properties at once to avoid timing issues
		$menu.css({
			'top': headerHeight + 'px',
			'height': (viewportHeight - headerHeight) + 'px'
		});

	}
}

function events() {
	var touchStartX, touchStartY, touchEndX, touchEndY;

	$(window).on('load resize', function() {

		if (window.innerWidth < s.pushMenuSwitch && s.push.hasClass('push--active')) {
			s.body.addClass('no-scroll');
		} else {
			s.body.removeClass('no-scroll');
		}

		// Update menu position on resize
		updateMenuPosition();
	});

	s.body.on('touchmove', function(event) {

		/** iOS requires this to disable touch scroll */
		// if (s.body.hasClass('no-scroll')) {
		// 	event.preventDefault();
		// 	// $('html, body').css({
		// 	// 	'height'   : '100%',
		// 	// 	'overflow' : 'hidden',
		// 	// });
		// }
	});

	s.body.on('mousedown touchstart', s.pushMenuSelector, function(event) {

		touchStartX = event.originalEvent.pageX;
		touchStartY = event.originalEvent.pageY;

	})
	.on('mouseup touchend', s.pushMenuSelector, function(event) {

		touchEndX = event.originalEvent.pageX;
		touchEndY = event.originalEvent.pageY;

		const touchUp    = touchStartY < touchEndY;
		const touchRight = touchStartX < touchEndX;
		const touchDown  = touchStartY > touchEndY;
		const touchLeft  = touchStartX > touchEndX;

		const touchLengthX  = Math.abs(touchStartX - touchEndX);
		const touchLengthY  = Math.abs(touchStartY - touchEndY);

		/** swipe back */
		if (touchRight && (touchLengthX > s.touchLengthMinX) && (touchLengthY < s.touchLengthMaxY)) { // swipe direction && threshold
			s.push.find('.push__level--current:not(.push__level--top)').find(s.pushLevelBackSelector).trigger('click');
		}
		// else if (touchLeft && (touchLengthX > s.touchLengthMinX) && (touchLengthY < s.touchLengthMaxY)) { // swipe direction && threshold
		// 	// do something
		// }
	});

	s.body.on('click', s.menuToggleSelector, function(event) {
    event.preventDefault();

		const isMenuActive = s.push.hasClass('push--active');
		
		if (!isMenuActive) {
			// Opening menu
			s.body.addClass('no-scroll');
			s.push.addClass('push--active');
			s.push.find('.push__level--top')
				.addClass('push__level--active')
				.addClass('push__level--current');

			// Show close button, hide open button
			$(s.menuOpenButtonSelector).hide();
			$(s.menuCloseButtonSelector).show();

			// Update position when menu opens
			updateMenuPosition();
		}

	}).on('click', s.pushLevelForwardSelector, function(event) {
    event.preventDefault();

		// Hide search form when going to submenu
		$(s.searchContainerSelector).addClass('search-container--hidden');

		s.push.find('.push__level--current')
			.removeClass('push__level--current');

		$(this).next('.push__level')
			.addClass('push__level--active')
			.addClass('push__level--current');

	}).on('click', s.pushLevelBackSelector, function(event) {
    event.preventDefault();

		const $thisLevel = $(this).closest('.push__level'); // this parent

		$thisLevel
			.removeClass('push__level--active')
			.removeClass('push__level--current')
			.closest('.push__level--active') // level parent
			.addClass('push__level--current');

		// Show search form when returning to top level
		// Check if the level we're going back to is the top level
		const $currentLevel = $(this).closest('.push__level');
		const $targetLevel = $currentLevel.closest('.push__level--active');
		
		if ($targetLevel.hasClass('push__level--top')) {
			$(s.searchContainerSelector).removeClass('search-container--hidden');
		}

		/** reset scroll */
		setTimeout(function() {
			// $thisLevel.scrollTop(0);
			$thisLevel.find('.push__level-inner')
				.scrollTop(0);
		}, 400); // transition

	}).on('click', s.accordionTriggerSelector, function(event) {
    event.preventDefault();

		const $trigger = $(this);
		const $content = $trigger.next(s.accordionContentSelector);
		const $icon = $trigger.find('i');
		const isExpanded = $trigger.attr('aria-expanded') === 'true';

		// Toggle the clicked accordion
		if (isExpanded) {
			// Close this accordion
			$trigger.attr('aria-expanded', 'false');
			$content.slideUp(300);
			// $icon.removeClass('fa-chevron-up').addClass('fa-chevron-down');
		} else {
			// Open this accordion
			$trigger.attr('aria-expanded', 'true');
			$content.slideDown(300);
			// $icon.removeClass('fa-chevron-down').addClass('fa-chevron-up');
		}

	}).on('click', s.menuCloseSelector, function(event) {
    event.preventDefault();

		// Closing menu
		s.body.removeClass('no-scroll');
		s.push.removeClass('push--active');

		// Show open button, hide close button
		$(s.menuOpenButtonSelector).show();
		$(s.menuCloseButtonSelector).hide();

		// Show search form when menu closes (returning to top level)
		$(s.searchContainerSelector).removeClass('search-container--hidden');

		s.push.find('.push__level--top')
			.addClass('push__level--active')
			.addClass('push__level--current');

		setTimeout(function() {

			/** reset scroll */
			s.push
				// .find('.push__level')
				// .scrollTop(0);
				.find('.push__level-inner')
				.scrollTop(0);

			/** reset active */
			s.push
				.find('.push__level--active')
				.removeClass('push__level--active');
		}, 400); // transition
	});
}

export {init as default};